import {
  COUNTRIES_LOADED,
  CREATE_DELIVERY_TYPE_FAILURE,
  CREATE_DELIVERY_TYPE_REQUEST,
  CREATE_DELIVERY_TYPE_SUCCESS,
  GET_BUILDING_DELIVERY_TYPES_FAILURE,
  GET_BUILDING_DELIVERY_TYPES_REQUEST,
  GET_BUILDING_DELIVERY_TYPES_SUCCESS,
  GET_DELIVERY_TYPES_FAILURE,
  GET_DELIVERY_TYPES_REQUEST,
  GET_DELIVERY_TYPES_SUCCESS,
  GET_DELIVERY_TYPE_FAILURE,
  GET_DELIVERY_TYPE_REQUEST,
  GET_DELIVERY_TYPE_SUCCESS,
  PUT_BUILDING_DELIVERY_TYPES_FAILURE,
  PUT_BUILDING_DELIVERY_TYPES_REQUEST,
  PUT_BUILDING_DELIVERY_TYPES_SUCCESS,
  REMOVE_DELIVERY_TYPE_FAILURE,
  REMOVE_DELIVERY_TYPE_REQUEST,
  REMOVE_DELIVERY_TYPE_SUCCESS,
  UPDATE_DELIVERY_TYPE_FAILURE,
  UPDATE_DELIVERY_TYPE_REQUEST,
  UPDATE_DELIVERY_TYPE_SUCCESS,
} from '../../actionConstants';
import { uploadImage } from '../Visitor/actionCreators';

import apiClient from '../../apiClient';
import { history } from '../../store';

export const getCountries = (dispatch, queryParams) =>
  dispatch({
    type: COUNTRIES_LOADED,
    payload: apiClient.aux.getCountries(queryParams),
  });

export const getDeliveryTypes = (dispatch, queryParams) =>
  dispatch({
    type: GET_DELIVERY_TYPES_REQUEST,
    payload: apiClient.deliveryTypes.getDeliveryTypes(queryParams).then(
      (res) =>
        dispatch({
          type: GET_DELIVERY_TYPES_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_DELIVERY_TYPES_FAILURE,
          err,
        }),
    ),
  });

export const getBuildingDeliveryTypes = (dispatch, buildingId, queryParams) =>
  dispatch({
    type: GET_BUILDING_DELIVERY_TYPES_REQUEST,
    payload: apiClient.deliveryTypes
      .getBuildingDeliveryTypes(buildingId, queryParams)
      .then(
        (res) =>
          dispatch({
            type: GET_BUILDING_DELIVERY_TYPES_SUCCESS,
            buildingId,
            res,
          }),
        (err) =>
          dispatch({
            type: GET_BUILDING_DELIVERY_TYPES_FAILURE,
            err,
          }),
      ),
  });

export const putPropertyDeliveryTypes = (dispatch, buildingId, data, pmcId) => {
  /* this endpoint can be used to PUT settings for building or PMC
  but GET works only on the building level */
  const propertyId = pmcId || buildingId;
  return dispatch({
    type: PUT_BUILDING_DELIVERY_TYPES_REQUEST,
    isForm: true,
    payload: apiClient.deliveryTypes
      .putPropertyDeliveryTypes(propertyId, data)
      .then(
        (res) => {
          dispatch({
            type: PUT_BUILDING_DELIVERY_TYPES_SUCCESS,
            buildingId,
            res,
          });
          return getBuildingDeliveryTypes(dispatch, buildingId, {
            disable_pagination: true,
          });
        },
        (err) => {
          dispatch({
            type: PUT_BUILDING_DELIVERY_TYPES_FAILURE,
            err,
          });
          return err;
        },
      ),
  });
};

export const getDeliveryTypeById = (dispatch, id) =>
  dispatch({
    type: GET_DELIVERY_TYPE_REQUEST,
    payload: apiClient.deliveryTypes.getDeliveryTypeById(id).then(
      (res) => {
        dispatch({
          type: GET_DELIVERY_TYPE_SUCCESS,
          res,
        });
      },
      (err) =>
        dispatch({
          type: GET_DELIVERY_TYPE_FAILURE,
          err,
        }),
    ),
  });

const uploadDeliveryTypeIcon = (dispatch, icons, deliveryTypeData) => {
  if (!icons?.length || icons?.[0]?.url) return null;
  const deliveryTypeId = deliveryTypeData?.data?.id;
  const url = `deliveries/types/${deliveryTypeId}/upload`;
  return uploadImage(dispatch, icons, url);
};

export const createDeliveryType = (dispatch, data) => {
  const { icons, ...rest } = data;
  return dispatch({
    type: CREATE_DELIVERY_TYPE_REQUEST,
    isForm: true,
    payload: apiClient.deliveryTypes.createDeliveryType(rest).then(
      async (res) => {
        dispatch({
          type: CREATE_DELIVERY_TYPE_SUCCESS,
          res,
        });
        await uploadDeliveryTypeIcon(dispatch, icons, res);
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: CREATE_DELIVERY_TYPE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

const formatDeliveryTypeData = (data) => {
  const { removeIcon, ...formattedData } = data;
  if (removeIcon) {
    formattedData.icons = null;
  }
  return formattedData;
};

export const updateDeliveryType = (dispatch, id, data) => {
  const { icons, ...rest } = data;
  const formattedData = formatDeliveryTypeData(rest);
  return dispatch({
    type: UPDATE_DELIVERY_TYPE_REQUEST,
    isForm: true,
    payload: apiClient.deliveryTypes.updateDeliveryType(id, formattedData).then(
      async (res) => {
        dispatch({
          type: UPDATE_DELIVERY_TYPE_SUCCESS,
          res,
        });
        await uploadDeliveryTypeIcon(dispatch, icons, res);
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: UPDATE_DELIVERY_TYPE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });
};

export const removeDeliveryType = (dispatch, id, data) =>
  dispatch({
    type: REMOVE_DELIVERY_TYPE_REQUEST,
    payload: apiClient.deliveryTypes.removeDeliveryType(id, data).then(
      (res) => {
        dispatch({
          type: REMOVE_DELIVERY_TYPE_SUCCESS,
          res,
        });
        return getDeliveryTypes(dispatch);
      },
      (err) =>
        dispatch({
          type: REMOVE_DELIVERY_TYPE_FAILURE,
          err,
        }),
    ),
  });
